import React from 'react';
import {
    FormInputField as FormInputFieldCore,
    FormInputFieldProps as FormInputFieldCoreProps,
} from '../common/FormInputField';
import { ProfileSetupFormSchema } from './ProfileSetupStep.schema';

interface FormInputFieldProps extends FormInputFieldCoreProps {
    name: keyof ProfileSetupFormSchema;
}

export const FormInputField: React.FC<FormInputFieldProps> = (props) => <FormInputFieldCore {...props} />;
